import {useCallback, useState} from 'react';

export const useGetCenteredSlideIndex = ({
  slideCount,
}: {
  slideCount: number;
}) => {
  const [inViewSlides, setInViewSlides] = useState<Set<number>>(new Set());

  const handleSlideInViewChange = useCallback(
    (slideIndex: number) => (isInView: boolean) => {
      setInViewSlides(prev => {
        const newSlides = new Set(prev);
        if (isInView && !newSlides.has(slideIndex)) {
          newSlides.add(slideIndex);
        } else if (!isInView && newSlides.has(slideIndex)) {
          newSlides.delete(slideIndex);
        }

        return newSlides;
      });
    },
    [],
  );

  const lastVisibleSlideIndex = Math.max(...inViewSlides.values());

  const centeredHighlightIndex =
    slideCount === 1
      ? lastVisibleSlideIndex
      : Array.from(inViewSlides).sort((a, b) => a - b)[
          Math.ceil(slideCount / 2) - 1
        ];

  return {
    centeredHighlightIndex,
    handleSlideInViewChange,
  };
};
